import { render, staticRenderFns } from "./HdsCheckboxCross.vue?vue&type=template&id=b22fd072&scoped=true&"
import script from "./HdsCheckboxCross.vue?vue&type=script&lang=ts&"
export * from "./HdsCheckboxCross.vue?vue&type=script&lang=ts&"
import style0 from "./HdsCheckboxCross.vue?vue&type=style&index=0&id=b22fd072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22fd072",
  null
  
)

export default component.exports